const name = 'IznvSound';

const mtof = (midi) => {
    return 440 * Math.pow(2, (midi - 69) / 12);
}
const tdur = (tempo, length) => {
    return (60 / tempo) * (4 / length);
}

const beep01 = (destination, playbackTime) => {
    var t0 = playbackTime;
    console.log('IznvSound.beep01 t0: ', t0);
    var t1 = t0 + tdur(180, 16);
    var t2 = t0 + tdur(180, 16) * 2;
    var t3 = t0 + tdur(180, 16) * 3;
    var t4 = t0 + tdur(180, 16) * 4;
    var t5 = t0 + tdur(180, 16) * 5;
    var si = mtof(95);
    var mi = mtof(102);
    var audioContext = destination.context;
    var oscillator = audioContext.createOscillator();
    var gain = audioContext.createGain();
    
    oscillator.type = "square";
    oscillator.frequency.setValueAtTime(si, t0);
    oscillator.frequency.linearRampToValueAtTime(mi, t3);
    oscillator.frequency.linearRampToValueAtTime(si, t5);
    oscillator.start(t0);
    oscillator.stop(t5);
    oscillator.connect(gain);
    
    gain.gain.setValueAtTime(0.5, t0);
    gain.gain.setValueAtTime(0, t1);
    gain.gain.setValueAtTime(0.5, t2);
    gain.gain.setValueAtTime(0, t3);
//		gain.gain.setValueAtTime(0.5, t4);
//		gain.gain.setValueAtTime(0, t5);
//		gain.gain.linearRampToValueAtTime(0, t5);
    gain.connect(destination);
}

export default {
    name: name,
    beep01: beep01,
}
